/* card-tilt.js — 3D Tilt Effect for all cards — Desktop only */
(function () {
  if (window.matchMedia('(hover: none)').matches) return;

  var TILT  = 10;
  var GLARE = 0.16;

  var SELECTOR = '.product-card, .cnl-card, .cypher-cat-card, .ctp__card, .cypher-jain-card, .cypher-jain-card--cta';

  function applyTilt(card) {
    if (card._tiltInit) return;
    card._tiltInit = true;

    /* ensure card has position for glare overlay */
    var pos = window.getComputedStyle(card).position;
    if (pos === 'static') card.style.position = 'relative';

    /* glare layer */
    var glare = document.createElement('div');
    glare.setAttribute('aria-hidden', 'true');
    glare.style.cssText = [
      'position:absolute', 'inset:0', 'border-radius:inherit',
      'pointer-events:none', 'z-index:99', 'opacity:0',
      'transition:opacity 0.25s ease',
      'background:radial-gradient(circle at 50% 50%, rgba(255,255,255,0.5) 0%, transparent 65%)',
      'will-change:background,opacity'
    ].join(';');
    card.appendChild(glare);

    card.style.willChange     = 'transform';
    card.style.transformStyle = 'preserve-3d';

    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top)  / rect.height;
      var rx = (y - 0.5) * -TILT * 2;
      var ry = (x - 0.5) *  TILT * 2;

      card.style.transition = 'transform 0.07s linear, box-shadow 0.07s linear';
      card.style.transform  = 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale3d(1.025,1.025,1.025)';
      card.style.boxShadow  = '0 20px 60px rgba(40,28,18,0.16)';

      glare.style.opacity    = GLARE;
      glare.style.background = 'radial-gradient(circle at ' + (x * 100) + '% ' + (y * 100) + '%, rgba(255,255,255,0.5) 0%, transparent 65%)';
    });

    card.addEventListener('mouseleave', function () {
      card.style.transition = 'transform 0.5s cubic-bezier(0.23,1,0.32,1), box-shadow 0.5s ease';
      card.style.transform  = 'perspective(900px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
      card.style.boxShadow  = '';
      glare.style.opacity   = '0';
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(applyTilt);
  }

  /* run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* re-run when Shopify injects new cards (e.g. infinite scroll, quick filters) */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTOR)) {
          applyTilt(node);
        }
        node.querySelectorAll && node.querySelectorAll(SELECTOR).forEach(applyTilt);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
